import React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { Outlet } from 'react-router-dom';
import UnauthenticatedTopBar from './UnauthenticatedTopBar';

export default function UnauthenticatedLayout() {
  return (
    <Box>
      <CssBaseline />
      <UnauthenticatedTopBar />
      <Box component='main'>
        <Outlet />
      </Box>
    </Box>
  );
}
